import { render } from "./AddTrafficAmountModal.vue?vue&type=template&id=06743ed7&ts=true"
import script from "./AddTrafficAmountModal.vue?vue&type=script&lang=ts"
export * from "./AddTrafficAmountModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__